
export type GlobalOnClickEventHandler = () => void;

let subscribers : { callBack: GlobalOnClickEventHandler, name: string }[];
subscribers = [];


export let sunbScribeOnClick = (callBack : GlobalOnClickEventHandler, name: string ) => {
    subscribers.push({callBack: callBack, name: name});
}

export let fireBodyClick = () => {
    subscribers.forEach(it => it.callBack());
}

export const unsubscribe = (name: string) => {
    subscribers = subscribers.filter(it => it.name != name);
}